import Link from 'src/components/ui/Link'

import type { ShopServiceMobileProps } from './shop-services'
import './shopServices.scss'

const ShopServiceMobile = ({ sources }: ShopServiceMobileProps) => {
  return (
    <div className="page-services-container-source">
      {sources.map((source, index) => (
        <div
          key={index}
          className="page-services-container-source-image-container"
        >
          <Link as="a" href={source.href}>
            <img
              className="page-services-container-source-image-container__img"
              src={source.srcSet}
              alt={source.alt}
              loading="lazy"
            />
            <p className="page-services-container-source-image-container__text">
              {source.text}
            </p>
          </Link>
        </div>
      ))}
    </div>
  )
}

export default ShopServiceMobile
